import React, {useContext, useEffect, useState} from 'react';
import {Button, Confirm, Dimmer, Header, Icon, Image, Label, Loader, Placeholder} from 'semantic-ui-react'
import {Context} from './index'
import {deleteCourses, getCourses, postCoursesCover, putCourseDeleteCover} from "../../../../../redux/actions";
import {CourseForm} from "./CourseForm";
import {useHistory} from "react-router";

export const Basic = () => {
    const ctx = useContext(Context);
    const history = useHistory();
    const course_id = ctx.course_id;

    const [course, setCourse] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showCover, setShowCover] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [showDeleteCourse, setShowDeleteCourse] = useState(false);
    const [showDeleteCover, setShowDeleteCover] = useState(false);

    const cover = course.cover ? course.path + course.cover : false;

    useEffect(() => window.scrollTo(0, 0))

    async function getData() {
        setLoading(true);
        setLoadingUpload(false);
        setShowForm(false);
        setShowDeleteCourse(false);
        setShowDeleteCover(false);

        try {
            // get data
            const res = await getCourses(course_id);
            // set data
            setCourse(res.data);
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false);
        }
    }

    async function handleDeleteCourse() {

        setLoadingDelete(true);

        try {
            const res = await deleteCourses(course_id);

            console.log(res);
        } catch (e) {
            console.log(e)
        } finally {
            history.goBack();
        }
    }

    async function handleDeleteCover() {

        setLoadingDelete(true);

        try {
            await putCourseDeleteCover(course_id);
            await getData();
        } catch (e) {
            console.log(e)
        } finally {
            setLoadingDelete(false);
        }
    }

    async function handleUploadCover(data) {
        setLoadingUpload(true);
        try {
            await postCoursesCover(data);
            await getData();
        } catch (e) {
            console.log(e);
        } finally {
            setLoadingUpload(false);
        }
    }

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        getData();

    }, [course_id])

    if (loading) {
        return (
            <Header>
                <Placeholder>
                    <Placeholder.Header image>
                        <Placeholder.Line/>
                        <Placeholder.Line/>
                    </Placeholder.Header>
                </Placeholder>
            </Header>
        )
    }

    return (
        <React.Fragment>
            {
                course.id && <CourseForm
                    show={showForm}
                    item={course}
                    onCancel={() => setShowForm(false)}
                    onSuccess={() => getData()}
                />
            }

            <Confirm
                open={showDeleteCourse}
                size={"tiny"}
                header={"Atenção"}
                content={`Deseja realmente excluir o curso "${course.name}"?`}
                cancelButton={<Button basic disabled={loadingDelete} content={'Cancelar'}/>}
                confirmButton={<Button
                    primary
                    disabled={loadingDelete}
                    loading={loadingDelete}
                    content={'Sim, quero excluir!'}
                />}
                onCancel={() => setShowDeleteCourse(false)}
                onConfirm={() => handleDeleteCourse()}
            />

            <Confirm
                open={showDeleteCover}
                size={"tiny"}
                header={"Atenção"}
                content={`Deseja realmente excluir a imagem do curso?`}
                cancelButton={<Button basic disabled={loadingDelete} content={'Cancelar'}/>}
                confirmButton={<Button
                    primary
                    disabled={loadingDelete}
                    loading={loadingDelete}
                    content={'Sim, quero excluir!'}
                />}
                onCancel={() => setShowDeleteCover(false)}
                onConfirm={() => handleDeleteCover()}
            />

            <Header style={{display: 'flex', marginTop: '1rem'}}>
                <Dimmer.Dimmable
                    dimmed={showCover || loadingUpload}
                    style={{marginRight: 12, minWidth: 213}}
                    onMouseEnter={() => setShowCover(true)}
                    onMouseLeave={() => setShowCover(false)}
                >
                    <Image
                        src={cover || 'https://img-a.udemycdn.com/course/240x135/1586752_2d9e_2.jpg'}
                        style={{height: 120}}
                    />

                    <Dimmer
                        active={showCover || loadingUpload}
                    >
                        {loadingUpload ? <Loader active={loadingUpload} inline/> : <Button.Group icon>
                            <Button
                                negative
                                icon={"trash"}
                                onClick={() => setShowDeleteCover(true)}
                                disabled={!course.cover}
                            />
                            <input
                                id='selectFile'
                                type={"file"}
                                name={"cover"}
                                style={{display: 'none'}}
                                onChange={(e) => {
                                    const formData = new FormData();
                                    formData.append('id', course_id);
                                    formData.append('cover', e.target.files[0]);

                                    // noinspection JSIgnoredPromiseFromCall
                                    handleUploadCover(formData);
                                }}
                            />
                            <label className={'ui button'} htmlFor={'selectFile'}>
                                <Icon name={"upload"}/>
                            </label>
                        </Button.Group>}
                    </Dimmer>
                </Dimmer.Dimmable>
                <Header.Content style={{flexGrow: 1, paddingRight: '1rem'}}>
                    {course.name} <Label>{course.course_category && course.course_category.name}</Label>
                    <Header.Subheader>{course.description && course.description.substr(0, 200)}...</Header.Subheader>
                    <div style={{marginTop: '1rem'}}>
                        <Button primary size={"tiny"} onClick={() => setShowForm(true)}>
                            <Icon name={"edit"}/>
                            Editar curso
                        </Button>
                        <Button negative size={"tiny"} floated={"right"} onClick={() => setShowDeleteCourse(true)}>
                            <Icon name={"trash"}/>
                            Excluir curso
                        </Button>
                    </div>
                </Header.Content>
            </Header>
        </React.Fragment>
    );
}